import { trim } from "jquery";

function displayAlertMessage(message: string) {
    return `
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
            ${message} 
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
    `
}

export default function handleOfferDetailFormLandlord() {
    const offerDetailForm = document.querySelector('#offerDetailForm') as HTMLElement;
    const offerDetailBackButton = document.querySelector('#offerDetailBackButton') as HTMLElement;
    const offerDetailPrevButton = document.querySelector('#offerDetailPrevButton') as HTMLElement;
    const offerDetailNextButton = document.querySelector('#offerDetailNextButton') as HTMLElement;
    const offerDetailSubmitButton = document.querySelector('#offerDetailSubmitButton') as HTMLElement;
    const clearSignatureBtn = document.querySelector('#clearSignatureBtn') as HTMLElement;
    const offerDetailPage1Elements = document.querySelectorAll('.fy-offer-detail-p1') as NodeList;
    const offerDetailPage2Title = document.querySelector('.fy-offer-detail-p2') as HTMLElement;
    const offerDetailRentContractWrap = document.querySelector('#offer-detail-rent-contract-wrap') as HTMLElement;
    // Form's input field
    const offerLandlordFullName = document.querySelector('#offerDetailForm input[name="offerLandlordFullName"]') as HTMLInputElement;
    const offerLandlordID = document.querySelector('#offerDetailForm input[name="offerLandlordID"]') as HTMLInputElement;
    const offerTenantFullName = document.querySelector('#offerDetailForm input[name="offerTenantFullName"]') as HTMLInputElement;
    const offerTenantID = document.querySelector('#offerDetailForm input[name="offerTenantID"]') as HTMLInputElement;
    const offerAddress = document.querySelector('#offerDetailForm input[name="offerAddress"]') as HTMLInputElement;
    const offerLandlordRegistrationNumber = document.querySelector('#offerDetailForm input[name="offerLandlordRegistrationNumber"]') as HTMLInputElement;
    // const offerLandlordID = document.querySelector('#offerDetailForm input[name="offerLandlordID"]') as HTMLInputElement;
    const petNumber = document.querySelector('#offerDetailForm input[name="petNumber"]') as HTMLInputElement;
    const heaterNumber = document.querySelector('#offerDetailForm input[name="heaterNumber"]') as HTMLInputElement;
    const airConNumber = document.querySelector('#offerDetailForm input[name="airConNumber"]') as HTMLInputElement;
    const rangeHoodNumber = document.querySelector('#offerDetailForm input[name="rangeHoodNumber"]') as HTMLInputElement;
    const cookingStoveNumber = document.querySelector('#offerDetailForm input[name="cookingStoveNumber"]') as HTMLInputElement;
    const refrigeratorNumber = document.querySelector('#offerDetailForm input[name="refrigeratorNumber"]') as HTMLInputElement;
    const washingMachineNumber = document.querySelector('#offerDetailForm input[name="washingMachineNumber"]') as HTMLInputElement;
    const exhaustFanNumber = document.querySelector('#offerDetailForm input[name="exhaustFanNumber"]') as HTMLInputElement;
    const keyNumber = document.querySelector('#offerDetailForm input[name="keyNumber"]') as HTMLInputElement;
    const offerDetailSignature = document.querySelector('#offerDetailForm input[name="offer_detail_signature"]') as HTMLInputElement;
    const offerDetailSignaturePDF = document.querySelector('#offerDetailSignaturePDF') as HTMLElement;

    // Rental contract field
    const rentContractLandlordFullname = document.querySelector('#rent-contract-landlord-fullname') as HTMLElement;
    const rentContractLandlordID = document.querySelector('#rent-contract-landlord-id') as HTMLElement;
    const rentContractTenantFullname = document.querySelector('#rent-contract-tenant-fullname') as HTMLElement;
    const rentContractTenantID = document.querySelector('#rent-contract-tenant-id') as HTMLElement;

    const rentContractAddress = document.querySelector('#rent-contract-address') as HTMLElement;
    const rentContractAmount = document.querySelector('#rent-contract-address') as HTMLElement;
    const rentContractLength = document.querySelector('#rent-contract-length') as HTMLElement;
    const rentContractStart = document.querySelector('#rent-contract-start') as HTMLElement;
    const rentContractEnd = document.querySelector('#rent-contract-end') as HTMLElement;
    const rentContractDeposit = document.querySelector('#rent-contract-deposit') as HTMLElement;
    const rentContractPetNumber = document.querySelector('#rent-contract-pet-number') as HTMLElement;
    const rentContractHeaterNumber = document.querySelector('#rent-contract-heater-number') as HTMLElement;
    const rentContractAirConNumber = document.querySelector('#rent-contract-air-number') as HTMLElement;
    const rentContractRangeHoodNumber = document.querySelector('#rent-contract-range-hood-number') as HTMLElement;
    const rentContractCookingStoveNumber = document.querySelector('#rent-contract-cooking-stove-number') as HTMLElement;
    const rentContractRefrigeratorNumber = document.querySelector('#rent-contract-refrigerator-number') as HTMLElement;
    const rentContractWashingMachineNumber = document.querySelector('#rent-contract-washing-machine-number') as HTMLElement;
    const rentContractExhaustFanNumber = document.querySelector('#rent-contract-exhaust-fan-number') as HTMLElement;
    const rentContractKeyNumber = document.querySelector('#rent-contract-key-number') as HTMLElement;
    // const rentContractLandlordRegistrationNumber = document.querySelector('#offer-detail-rent-contract-sign-area-landlord-registration-number') as HTMLElement;
    // const rentContractLandlordID = document.querySelector('#offer-detail-rent-contract-sign-area-landlord-id') as HTMLElement;

    // initial setup
    if (offerDetailRentContractWrap) {
        if (offerDetailPage1Elements.length != 0) {
            rentContractLandlordFullname.innerText = '';
            rentContractLandlordID.innerText = '';
            rentContractTenantFullname.innerText = '';
            rentContractTenantID.innerText = '';
            rentContractAddress.innerText = '';
            rentContractPetNumber.innerText = '';
            rentContractHeaterNumber.innerText = '';
            rentContractAirConNumber.innerText = '';
            rentContractRangeHoodNumber.innerText = '';
            rentContractCookingStoveNumber.innerText = '';
            rentContractRefrigeratorNumber.innerText = '';
            rentContractWashingMachineNumber.innerText = '';
            rentContractExhaustFanNumber.innerText = '';
            rentContractKeyNumber.innerText = '';
            const signatureElements = offerDetailRentContractWrap.querySelectorAll(".rent-contract-sign-image-wrapper") as NodeList;
            (signatureElements[0] as HTMLElement).innerText = '';
            (signatureElements[1] as HTMLElement).innerText = '';
        }
        const rentContractWrapper = offerDetailRentContractWrap.querySelector('.rent-contract-wrapper') as HTMLElement;
        rentContractWrapper.classList.remove('hide');
    }

    // Alert message section
    const alertMessage = document.querySelector('#offerDetailForm .form_messages') as HTMLElement;

    if (offerDetailForm) {
        if (offerDetailNextButton) {
            offerDetailNextButton.addEventListener('click', e=> {
                e.preventDefault();
                if (!offerLandlordFullName.value) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入業主姓名');
                }
                else if (!offerLandlordID.value) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入業主身份證號碼');
                }
                else if (!offerTenantFullName.value) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入租戶姓名');
                }
                else if (!offerTenantID.value) {
                    alertMessage.innerHTML = displayAlertMessage('租戶身份證號碼');
                }
                else if (!offerAddress.value) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入租盤詳細地址');
                }
                else if (!offerLandlordID.value) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入業主身份證號碼');
                }
                else if (petNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入允許飼養寵物數目');
                }
                else if (Number(petNumber.value) < 0 || (Number(petNumber.value) >= 0 && !Number.isInteger(Number(petNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('飼養寵物數目需為零或以上正整數');
                }
                else if (heaterNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入熱水爐數目');
                }
                else if (Number(heaterNumber.value) < 0 || (Number(heaterNumber.value) >= 0 && !Number.isInteger(Number(heaterNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('熱水爐數目需為零或以上正整數');
                }
                else if (airConNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入冷氣機數目');
                }
                else if (Number(airConNumber.value) < 0 || (Number(airConNumber.value) >= 0 && !Number.isInteger(Number(airConNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('冷氣機數目需為零或以上正整數');
                }
                else if (rangeHoodNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入抽油煙機數目');
                }
                else if (Number(rangeHoodNumber.value) < 0 || (Number(rangeHoodNumber.value) >= 0 && !Number.isInteger(Number(rangeHoodNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('抽油煙機數目需為零或以上正整數');
                }
                else if (cookingStoveNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入煮食爐數目');
                }
                else if (Number(cookingStoveNumber.value) < 0 || (Number(cookingStoveNumber.value) >= 0 && !Number.isInteger(Number(cookingStoveNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('煮食爐數目需為零或以上正整數');
                }
                else if (refrigeratorNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入雪櫃數目');
                }
                else if (Number(refrigeratorNumber.value) < 0 || (Number(refrigeratorNumber.value) >= 0 && !Number.isInteger(Number(refrigeratorNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('雪櫃數目需為零或以上正整數');
                }
                else if (washingMachineNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入洗衣機數目');
                }
                else if (Number(washingMachineNumber.value) < 0 || (Number(washingMachineNumber.value) >= 0 && !Number.isInteger(Number(washingMachineNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('洗衣機數目需為零或以上正整數');
                }
                else if (exhaustFanNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入抽氣扇數目');
                } 
                else if (Number(exhaustFanNumber.value) < 0 || (Number(exhaustFanNumber.value) >= 0 && !Number.isInteger(Number(exhaustFanNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('抽氣扇數目需為零或以上正整數');
                }
                else if (keyNumber.value.length == 0) {
                    alertMessage.innerHTML = displayAlertMessage('請輸入大門房門及信箱鎖匙數目');
                } 
                else if (Number(keyNumber.value) < 0 || (Number(keyNumber.value) >= 0 && !Number.isInteger(Number(keyNumber.value)))) {
                    alertMessage.innerHTML = displayAlertMessage('大門房門及信箱鎖匙數目需為零或以上正整數');
                }
                else {
                    offerDetailNextButton.classList.add('hidden');
                    offerDetailSubmitButton.classList.remove('hidden');
                    offerDetailBackButton.classList.add('hidden');
                    offerDetailPrevButton.classList.remove('hidden');
                    
                    alertMessage.innerHTML = "";

                    rentContractLandlordFullname.innerText = offerLandlordFullName.value.trim();
                    rentContractLandlordID.innerText = offerLandlordID.value.trim();
                    rentContractTenantFullname.innerText = offerTenantFullName.value.trim();
                    rentContractTenantID.innerText = offerTenantID.value.trim();
                    rentContractAddress.innerText = offerAddress.value.trim();
                    rentContractPetNumber.innerText = petNumber.value;
                    rentContractHeaterNumber.innerText = heaterNumber.value;
                    rentContractAirConNumber.innerText = airConNumber.value;
                    rentContractRangeHoodNumber.innerText = rangeHoodNumber.value;
                    rentContractCookingStoveNumber.innerText = cookingStoveNumber.value;
                    rentContractRefrigeratorNumber.innerText = refrigeratorNumber.value;
                    rentContractWashingMachineNumber.innerText = washingMachineNumber.value;
                    rentContractExhaustFanNumber.innerText = exhaustFanNumber.value;
                    rentContractKeyNumber.innerText = keyNumber.value;
                    // rentContractLandlordRegistrationNumber.innerText = offerLandlordRegistrationNumber.value;
                    // rentContractLandlordID.innerText = offerLandlordID.value;
                    offerDetailPage1Elements.forEach(offerDetailPage1Element => {
                        (offerDetailPage1Element as HTMLElement).classList.add('hidden');
                    });
                    offerDetailPage2Title.classList.remove('hidden');
                    offerDetailRentContractWrap.classList.remove('hidden');
                }
            })
        }
        if (offerDetailPrevButton) {
            offerDetailPrevButton.addEventListener('click', e=> {
                e.preventDefault();
                offerDetailNextButton.classList.remove('hidden');
                offerDetailSubmitButton.classList.add('hidden');
                offerDetailBackButton.classList.remove('hidden');
                offerDetailPrevButton.classList.add('hidden');
                offerDetailPage1Elements.forEach(offerDetailPage1Element => {
                    (offerDetailPage1Element as HTMLElement).classList.remove('hidden');
                });
                offerDetailPage2Title.classList.add('hidden');
                offerDetailRentContractWrap.classList.add('hidden');
            })
        }
        if (clearSignatureBtn) {
            clearSignatureBtn.addEventListener('click', e => {
                // Clear the signature
                e.preventDefault();
                offerDetailSignaturePDF.innerHTML = "";
                (jQuery('.js-signature') as any).jqSignature('clearCanvas');
                let dataUrl = (jQuery('.js-signature') as any).jqSignature('getDataURL');
                // console.log(dataUrl);
                offerDetailSignature.setAttribute('value', "");
            })
        }
        jQuery('.js-signature').on('jq.signature.changed', function() {
            // Display the signature on the Agreement form and set the hidden input value.
            offerDetailSignaturePDF.innerHTML = "";
            let dataUrl = (jQuery('.js-signature') as any).jqSignature('getDataURL');
            let img = document.createElement('img');
            img.setAttribute('src', dataUrl);
            offerDetailSignaturePDF.append(img);
            // console.log(dataUrl);
            offerDetailSignature.setAttribute('value', dataUrl);
        });
    }
}